import React, { useEffect } from 'react';

const Toast = ({ message, onClose }) => {
  // This effect will automatically call the onClose function after 3 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 3000);

    // This is a cleanup function. If the component is removed before 3 seconds,
    // it prevents the timer from trying to update a non-existent component.
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className="toast-notification">
      {message}
    </div>
  );
};

export default Toast;
